<template>
  <div>
    <template v-if="allowedStaff">
      <Team :entity="entity" />
      <EmailSignature :entity="entity" />
    </template>
    <StaffZ
      :entity="entity"
      v-if="allowedStaffModule"
      @triggerUpdate="triggerUpdate"
    />
  </div>
</template>

<script>
import EmailSignature from "@/components/entity/staff/EmailSignature";
import StaffZ from "@/components/entity/staff/Staff";
import Team from "@/components/entity/staff/Team";
export default {
  name: "Staff",
  components: {
    EmailSignature,
    StaffZ,
    Team
  },
  props: ["entity", "allowedStaff", "allowedStaffModule"],
  methods: {
    triggerUpdate() {
      this.$emit("triggerUpdate");
    }
  }
};
</script>
